import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { OperacaoFinanceiraDetalharComponent } from "./operacao-financeira-detalhar.component";
import { OperacaoFinanceiraDetalharRoutingModule } from "./operacao-financeira-detalhar-routing.module";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";




@NgModule({
    imports: [
        CommonModule,
        OperacaoFinanceiraDetalharRoutingModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        MessagesModule,
        ProgressSpinnerModule

    ],
    declarations: [OperacaoFinanceiraDetalharComponent]
})
export class OperacaoFinanceiraDetalharModule { }
